import {
	FishQuality,
	FishState,
	OtherItemsState,
	SubItems
} from '../types'

export const DEFAULT_FISH_STATE = {} as FishState

export const DEFAULT_FISH_QUALITY_STATE = {} as FishQuality

export const FISH_DEFAULT_INPUT_VALUE = ''

export const OTHER_ITEMS_DEFAULT_INPUT_VALUE = ''

export const OTHER_ITEMS_STATE_DEFAULT_VALUE = {} as OtherItemsState

export const OTHER_ITEMS_SUB_ITEMS_DEFAULT_VALUE = {} as SubItems